export default __webpack_public_path__ + "b6e55bb6144cc86cf27aca542d3fe20f.svg";